'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { Checkbox } from '@personly/libs-widgets';
import type { CookieType } from '@personly/libs-types';
import { useConsents } from '@/providers/consents';
interface Props {
  cookieTypes: CookieType[];
}
const CookieTypesSelect = t0 => {
  const $ = _c(12);
  const {
    cookieTypes
  } = t0;
  const {
    selectedCookieTypes,
    setSelectedCookieTypes
  } = useConsents();
  let t1;
  if ($[0] !== selectedCookieTypes) {
    t1 = handle => selectedCookieTypes.includes(handle);
    $[0] = selectedCookieTypes;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const checked = t1;
  let t2;
  if ($[2] !== selectedCookieTypes || $[3] !== setSelectedCookieTypes) {
    t2 = handle_0 => {
      if (selectedCookieTypes.includes(handle_0)) {
        setSelectedCookieTypes(value => value.filter(typeHandle => typeHandle !== handle_0));
      } else {
        setSelectedCookieTypes(value_0 => [...value_0, handle_0]);
      }
    };
    $[2] = selectedCookieTypes;
    $[3] = setSelectedCookieTypes;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const select = t2;
  let t3;
  if ($[5] !== checked || $[6] !== cookieTypes || $[7] !== select) {
    let t4;
    if ($[9] !== checked || $[10] !== select) {
      t4 = cookieType => <div key={cookieType.handle}><div className="flex flex-row"><div className="pr-2"><Checkbox disabled={cookieType.flags.isDisabled} checked={checked(cookieType.handle)} onChange={() => select(cookieType.handle)} /></div><div>{cookieType.title}</div></div></div>;
      $[9] = checked;
      $[10] = select;
      $[11] = t4;
    } else {
      t4 = $[11];
    }
    t3 = cookieTypes.map(t4);
    $[5] = checked;
    $[6] = cookieTypes;
    $[7] = select;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default CookieTypesSelect;